import store from '@state/store';
export const logout = () => {
    return store.dispatch('auth/logout');
};
const authHelper = { logout };
export default authHelper;
